module.exports = __webpack_public_path__ + "img/AC_Motor.124cf6c2.svg";